/**
 * @description 支持跨子域的local
 * 兼容 ie8+
 *
 * @author riverhan
 * @data 2016-10-11
 *
 * 使用方法：
 * var getLocal = require('local.data/power.local');
 * var localData = {};
 *
 * getLocal({
 *     whiteDomain: [],
 *     iframeUrl: 'xxx'
 * }, function(powerLocal){
 *     localData = powerLocal;
 * });
 *
 * 注意：
 * 因为使用跨域的localstorage时，所有操作都是异步的，结果都是在回调函数中，
 * 就连localData的生成也是异步的（因为要等iframe ready）
 * 所以在使用的时候，会有些麻烦。
 * 又因为是异步的，所以同时有多个地方操作localstorage时，需要特别注意数据的读写冲突
 *
 * Tip: 除非真的确定要用跨子域的功能，才用这个模块。否则推荐使用基本的local.data即可
 *      异步的localstorage使用起来毕竟比较麻烦。
 */

var localData = require('@tencent/im-local.data/local.data');
var crossLocal = require('@tencent/im-local.data/cross.local');
var _opt = {
    whiteDomain: [],
    iframeUrl: '',
    crossDomain: false
};

/**
 * 简单的浅拷贝扩展
 * @param  {Object} object        扩展数据对象
 * @param  {Object} defaultObject 目标数据对象
 * @return {Object}               扩展后的对象
 */
function _extend(object, defaultObject) {
    var result = defaultObject || {};
    var key;
    for (key in object) {
        if (object.hasOwnProperty(key)) {
            result[key] = object[key];
        }
    }
    return result;
}

/**
 * 检测是否需要跨域
 * @return {Boolean} 是否需要跨域操作localstorage
 */
function _isCrossDomain() {
    var domain = document.domain;
    var whiteDomain = _opt.whiteDomain;
    var isCross = false;

    if (!_opt.crossDomain) { // 如果设置了不用跨域，直接返回false
        return false;
    }

    if (whiteDomain.length === 0) {
        return false;
    }

    for (var i = 0; i < whiteDomain.length; i++) {
        if (domain === whiteDomain[i]) {
            break;
        }
    }

    if (i === whiteDomain.length) {
        isCross = true;
    }

    return isCross;
}

/**
 * localstorage操作封装，将同域和跨域的操作，都统一为一样的对外接口
 * 所有操作暴露出去均为异步操作。
 * @param  {[type]}  local   [description]
 * @param  {Boolean} isCross [description]
 */
function _crossWrap(local, isCross) {
    return {
        get: function(key, cb) {
            if (isCross) {
                local.get(key, function(data) {
                    cb && cb(data && data.value);
                });
            } else {
                cb && cb(local.get(key));
            }
        },
        set: function(key, value, cb) {
            try {
                if (isCross) {
                    local.set(key, value, cb);
                } else {
                    local.set(key, value);
                    cb && cb();
                }
            } catch (e) {
                if (e.name === 'QuotaExceededError') {
                    window.BJ_REPORT && BJ_REPORT.debug({
                        msg: 'local-write-overflow',
                        ext: {
                            msid: 2514080
                        }
                    });
                }
            }

        },
        remove: function(key, cb) {
            if (isCross) {
                local.remove(key, cb);
            } else {
                local.remove(key);
                cb && cb();
            }
        },
        filter: function(reg, cb) {
            if (isCross) {
                local.filter(reg, function(data) {
                    cb && cb(data && data.value);
                });
            } else {
                cb && cb(local.filter(reg));
            }
        },
        clear: function(cb) {
            if (isCross) {
                local.clear(cb);
            } else {
                local.clear();
                cb && cb();
            }
        },
        wasInit: function() {
            return isCross ? local.wasInit() : true;
        },
        isCross: function() {
            return isCross;
        }
    };
}

/**
 * 获取local
 * @param  {[type]} opt [description]
 * @return {[type]}      [description]
 */
function getLocal(opt, cb) {
    _extend(opt, _opt);

    if (_isCrossDomain()) {
        // 跨域时,使用cross.local
        localData = crossLocal;
        localData.init({
            iframeUrl: _opt.iframeUrl,
            initCallback: function () {
                console.log('iframe inited');
                cb && cb(_crossWrap(localData, true));
            }
        });
    } else {
        cb && cb(_crossWrap(localData));
    }
}

module.exports = {
    getLocal: getLocal
};
